var _ = require('underscore');
module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="CDB-Widget-header js-header"></div>\n<div class="CDB-Widget-content CDB-Widget-content--noSidesMargin">\n  <div class="CDB-Widget-listWrapper js-content"></div>\n</div>\n<div class="CDB-Widget-footer js-footer"></div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./lib/assets/javascripts/deep-insights/widgets/category/content-template.tpl
// module id = 906
// module chunks = 0 2